const normalizeTrimmedText = (value) => (value == null ? '' : String(value).trim());
const normalizeText = (value) => (value == null ? '' : String(value));

export const normalizePatientCategory = (value) => (
  value == null || value === '' || value === 'None' ? null : value
);

const validDateParts = (year, month, day) => {
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year
    && date.getUTCMonth() === month - 1
    && date.getUTCDate() === day;
};

const validDOBParts = (value) => {
  const text = String(value);
  const isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const separatedMatch = text.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/);
  const compactMatch = text.match(/^(\d{2})(\d{2})(\d{4})$/);
  const match = isoMatch || separatedMatch || compactMatch;
  if (!match) return null;

  const [year, month, day] = isoMatch
    ? [Number(match[1]), Number(match[2]), Number(match[3])]
    : [Number(match[3]), Number(match[1]), Number(match[2])];
  return validDateParts(year, month, day) ? [year, month, day] : null;
};

export const isValidPatientDOB = (value) => (
  value != null && value !== '' && validDOBParts(value) !== null
);

const normalizeDOB = (value) => {
  if (value == null || value === '') return null;

  const parts = validDOBParts(value);
  if (!parts) return value;
  const [year, month, day] = parts;

  return `${year.toString().padStart(4, '0')}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
};

export const normalizePatientDraft = (draft) => ({
  patientFirstName: normalizeTrimmedText(draft.patientFirstName),
  patientMiddleName: normalizeTrimmedText(draft.patientMiddleName),
  patientLastName: normalizeTrimmedText(draft.patientLastName),
  patientDOB: normalizeDOB(draft.patientDOB),
  patientPhoneNumber: normalizeTrimmedText(draft.patientPhoneNumber),
  documentTitle: normalizeText(draft.documentTitle),
  documentCategory: normalizePatientCategory(draft.documentCategory),
  privacyLevel: normalizeText(draft.privacyLevel),
  referralNote: normalizeText(draft.referralNote),
  referringProvider: normalizeTrimmedText(draft.referringProvider),
  referringProviderOffice: normalizeTrimmedText(draft.referringProviderOffice),
});

export const buildSparsePatientChanges = (openingBaseline, draft) => {
  const baseline = normalizePatientDraft(openingBaseline);
  const current = normalizePatientDraft(draft);
  const changes = {};
  const nameChanged = (
    baseline.patientFirstName !== current.patientFirstName
    || baseline.patientMiddleName !== current.patientMiddleName
    || baseline.patientLastName !== current.patientLastName
  );

  if (nameChanged) {
    changes.patient_first_name = current.patientFirstName;
    changes.patient_middle_name = current.patientMiddleName;
    changes.patient_last_name = current.patientLastName;
  }
  if (baseline.patientDOB !== current.patientDOB) changes.patient_dob = current.patientDOB;
  if (baseline.patientPhoneNumber !== current.patientPhoneNumber) {
    changes.patient_phone_number = current.patientPhoneNumber;
  }
  if (baseline.documentTitle !== current.documentTitle) changes.document_title = current.documentTitle;
  if (baseline.documentCategory !== current.documentCategory) {
    changes.document_category_id = current.documentCategory;
  }
  if (baseline.privacyLevel !== current.privacyLevel && current.privacyLevel !== '') {
    // An empty privacy level means the control was unavailable, not that privacy
    // should be cleared.
    changes.privacy_level = current.privacyLevel;
  }
  if (baseline.referralNote !== current.referralNote) changes.referral_note = current.referralNote;
  if (baseline.referringProvider !== current.referringProvider) {
    changes.referring_provider = current.referringProvider;
  }
  if (baseline.referringProviderOffice !== current.referringProviderOffice) {
    changes.provider_office = current.referringProviderOffice;
  }

  return changes;
};
